import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export function DeltaBadge({ value, suffix = '', prefix = '' }) {
  if (value === undefined || value === null) return null;
  const isUp = value > 0;
  const Icon = isUp ? TrendingUp : TrendingDown;
  const color = isUp ? 'text-red-600 bg-red-50' : 'text-emerald-600 bg-emerald-50';
  return (
    <span className={`inline-flex items-center gap-0.5 text-[10px] font-medium px-1.5 py-0.5 rounded-full mt-1 ${color}`}>
      <Icon className="w-3 h-3" />
      {value > 0 ? '+' : ''}{prefix}{typeof value === 'number' ? value.toLocaleString(undefined, { maximumFractionDigits: 1 }) : value}{suffix}
    </span>
  );
}

export function SummaryCard({ icon: Icon, label, value, delta, suffix = '', subtext }) {
  return (
    <Card data-testid={`summary-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <CardContent className="pt-4 pb-3 px-4">
        <div className="flex items-center gap-2 mb-1">
          <Icon className="w-4 h-4 text-slate-400" />
          <span className="text-[10px] text-slate-500 uppercase tracking-wide">{label}</span>
        </div>
        <div className="text-xl font-bold text-[#0F2040]">{value}</div>
        {subtext && <div className="text-[10px] text-slate-400 mt-0.5">{subtext}</div>}
        {delta !== undefined && delta !== null && <DeltaBadge value={delta} suffix={suffix} />}
      </CardContent>
    </Card>
  );
}
